import React from "react";
import "./footer.scss";
import ig from "../../assets/images/socialimg/ig.png";
import ln from "../../assets/images/socialimg/ln.png";
import yt from "../../assets/images/socialimg/yt.png";
import VerticalLogoName from "../../assets/images/logo/VerticalLogoName.png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const navs = [
    {
      id: 1,
      text: "Who we are",
      path: "/dashboard/about-us",
    },
	{
		id: 2,
		text: "Contact Us",
		path: "/dashboard/contact-us",
	  },
	{
		id: 3,
		text: "Privacy Policy",
		path: "/dashboard/privacy-policy",
	  },
    {
      id: 4,
      text: "Terms & Conditions",
      path: "/dashboard/terms&Conditions",
    },
	{
		id: 5,
		text: "Community Guidelines",
		path: "/dashboard/community-guidelines",
	  },
    {
      id: 6,
      text: "Refunds",
      path: "/dashboard/refunds",
      },
   
    
   
  ];
  return (
	<>
      <div className="footer-container">

	  <div className="logo-nav">
            <div className="logo-cont">
              <img src={VerticalLogoName} className="logo-img" alt="Aerial Borne Logo" />
            </div>
			</div>
        <div className="nav-social-container">
         
            <div className="nav">
              {navs.map((nav) => (
                <div
                  key={nav.id}
                  className="stepItem"
                  onClick={() => navigate(nav.path)}
                >
                  <p className="stepText">{nav.text}</p>
                </div>
              ))}
            </div>
          {/* </div> */}
          <div className="company-media">
            <div className="media-icons">
              <a title="Instagram" href="https://www.instagram.com/aerial.borne" target="_blank" rel="noreferrer">
                <img src={ig} alt="Instagram" />
              </a>
              <a title="LinkedIn" href="https://www.linkedin.com/company/aerialborne/" target="_blank" rel="noreferrer">
                <img src={ln} alt="LinkedIn" />
              </a>
              <a title="YouTube" href="https://www.youtube.com/@aerialborne" target="_blank" rel="noreferrer">
                <img src={yt} alt="YouTube" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <p className="bottom-text">© 2025 Aerial Borne. All rights reserved.</p>
    </>
  );
};

export default Footer;
